import { useContext, useEffect, useState } from "react";
import { config } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useProductCategory = () => {
  const { t } = useLocale();
  const Actor = useElement("Actor");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { generateUID, closeModal, showAlert, slugify, isBottom } =
    useService("Misc");
  const {
    getProductCategory,
    deleteProductCategory,
    addProductCategory: publishProductCategory,
  } = useService("Product");
  const { commonPageSize } = config;
  const [tableContent, settableContent] = useState(null);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [categoryList, setcategoryList] = useState([]);
  const [catName, setcatName] = useState<string>("");
  const [catSlug, setcatSlug] = useState<string>("");
  const [parentCat, setparentCat] = useState(null);
  const [renderSlug, setrenderSlug] = useState<boolean>(true);
  const [activeItem, setactiveItem] = useState(null);
  const [uid, setuid] = useState<string>("");
  const [showTrashConfirm, setshowTrashConfirm] = useState<boolean>(false);
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [categoryOptions, setcategoryOptions] = useState([]);
  const [filteredList, setfilteredList] = useState([]);

  setTitle("Product Category", "admin");
  useEffect(() => {
    getProductCategoryData();
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getProductCategoryData = async () => {
    const result = await getProductCategory();
    if (result.status) {
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: "No chats placed yet!" });
        setcategoryList([]);
        setcategoryOptions([]);
      } else {
        let categoryList = [],
          categoryOptions = [];
        result.data.forEach((e) => {
          categoryList.push(e);
          categoryOptions.push({ label: e.catName, value: e.catSlug });
        });
        setcategoryList(categoryList);
        setcategoryOptions(categoryOptions);
      }
    }
  };

  const categoryCancel = () => {
    setactiveItem(null);
    setshowTrashConfirm(false);
  };

  const trashCategory = async () => {
    let query = {
      uid: activeItem.uid,
    };
    const result = await deleteProductCategory(query);
    if (result.status) {
      getProductCategoryData();
      showAlert({ type: "success", msg: "Category deleted successfully!" });
      setactiveItem(null);
      setshowTrashConfirm(false);
    } else showAlert({ type: "error", msg: "Unable to delete chat!" });
  };

  const addProductCategory = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      parentCategory = "";
    if (parentCat !== "") parentCategory = parentCat.label;
    let categoryObject = {
      catName: catName,
      catSlug: catSlug,
      parentCat: parentCategory,
      uid: generateUID(),
    };
    if (catName === "" || catSlug === "") {
      errorMsg = "Please enter chat content!";
      error = true;
    }
    if (!error) {
      const result = await publishProductCategory(categoryObject);
      if (result.status)
        showAlert({ type: "success", msg: "Category added successfully!" });
      else showAlert({ type: "error", msg: "Unable to add chat!" });
      setcatName("");
      setcatSlug("");
      setparentCat("");
      setuid("");
      closeModal("category-modal");
      getProductCategoryData();
    } else showAlert({ type: "error", msg: errorMsg });
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.forEach((item) => {
      let e = {
        catName: <p className="query mb40">{item.catName}</p>,
        catSlug: <p className="ans mb40">{item.catSlug}</p>,
        parentCat: <p className="ans mb40">{item.parentCat}</p>,
        action: (
          <div className="action-bar" style={{ bottom: 10 }}>
            <Actor
              type="trash"
              onClick={() => {
                setactiveItem(item);
                setshowTrashConfirm(true);
              }}
            />
          </div>
        ),
      };
      data.push(e);
    });
    return data;
  };

  const addCategoryName = (e) => {
    let tempTitle = e.target.value,
      tempSlug = catSlug;
    if (renderSlug) {
      tempSlug = slugify(tempTitle);
    }
    setcatName(tempTitle);
    setcatSlug(tempSlug);
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: "Category Name",
          key: "categoryName",
        },
        {
          label: "Slug",
          key: "slug",
        },
        {
          label: "Parent Category",
          key: "parentCategory",
        },
        {
          label: t("actions"),
          key: "actions",
        },
      ],
      content: getTableData(categoryList),
    });
  }, [categoryList]);
  return {
    trackScrolling,
    setmode,
    tableContent,
    activeShownTotal,
    trashCategory,
    categoryCancel,
    showTrashConfirm,
    setcatName,
    setuid,
    addProductCategory,
    catName,
    addCategoryName,
    catSlug,
    setcatSlug,
    parentCat,
    setparentCat,
    categoryOptions,
  };
};
